import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import map from 'lodash/map';
import find from 'lodash/find';

import { Link } from 'shared/lib/SureDesignSystem';

import styles from './SubMenu.module.css';

const propTypes = {
  className: PropTypes.string,
  onToggle: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
  isButton: PropTypes.bool,
  isOpen: PropTypes.bool,
  isMobile: PropTypes.bool,
  isProfile: PropTypes.bool,
  groups: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      items: PropTypes.arrayOf(
        PropTypes.shape({
          title: PropTypes.string,
          href: PropTypes.string,
          isNew: PropTypes.bool,
          useChevron: PropTypes.bool,
        })
      ),
    })
  ),
  items: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      description: PropTypes.string,
      href: PropTypes.string,
      icon: PropTypes.node,
      useChevron: PropTypes.bool,
    })
  ),
};

const defaultProps = {
  className: null,
  isOpen: false,
  groups: [],
  items: [],
};

class SubMenu extends PureComponent {
  componentDidMount() {
    if (this.props.isOpen) {
      document.addEventListener('mousedown', this.handleOutsideClick, false);
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isOpen !== this.props.isOpen) {
      if (this.props.isOpen) {
        document.addEventListener('mousedown', this.handleOutsideClick, false);
      } else {
        document.removeEventListener(
          'mousedown',
          this.handleOutsideClick,
          false
        );
      }
    }
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleOutsideClick, false);
  }

  handleOutsideClick = e => {
    if (this.subMenu.contains(e.target)) {
      return;
    } else if (e.target.id === 'backButton') {
      this.props.onBack();
    } else {
      this.props.onClose();
    }
  };

  render() {
    const {
      className,
      children,
      groups,
      items,
      isButton,
      isMobile,
      isOpen,
      isProfile,
      onToggle,
      onClose,
    } = this.props;

    const isFullWidth = !!find(groups, group => group.icon);

    return (
      <div
        className={classnames(
          styles.wrapper,
          {
            [styles.isOpen]: isOpen,
          },
          className
        )}
        ref={c => (this.subMenu = c)}
      >
        <div>
          <Link
            className={classnames(styles.title, {
              [styles.titleButton]: isButton,
              [styles.titleProfile]: isProfile,
            })}
            onClick={onToggle}
          >
            {isOpen && isButton && isMobile ? 'Insurance' : children}
          </Link>

          {isOpen && groups.length > 0 && (
            <div
              className={classnames([
                styles.subMenuContent,
                isFullWidth && styles.subMenuContentFullWidth,
              ])}
            >
              {map(groups, (group, i) => (
                <div key={i} className={styles.subItemsGroup}>
                  {group.icon && (
                    <div className={styles.iconWrapper}>{group.icon}</div>
                  )}

                  <div className={styles.groupContentContainer}>
                    <span className={styles.groupTitle}>{group.title}</span>

                    <div className={styles.subItems}>
                      {map(group.items, (item, j) => (
                        <Link
                          key={j}
                          to={item.href}
                          onClick={onClose}
                          className={classnames(styles.item, {
                            [styles.isNew]: item.isNew,
                          })}
                        >
                          {item.title}
                          {item.useChevron && (
                            <i
                              align="right"
                              className={classnames(
                                'fas fa-chevron-right',
                                styles.iconRight
                              )}
                            />
                          )}
                        </Link>
                      ))}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}

          {isOpen && items.length > 0 && (
            <div
              className={classnames(
                styles.subMenuContent,
                styles.subMenuColumn
              )}
            >
              {map(items, (item, i) => (
                <Link
                  key={i}
                  to={item.href}
                  onClick={item.onClick}
                  className={item.icon ? styles.itemWithIcon : styles.item}
                >
                  {item.icon && (
                    <div className={styles.iconWrapper}>{item.icon}</div>
                  )}
                  <div>
                    <span className={styles.itemTitle}>{item.title}</span>
                    <p className={styles.itemDescription}>{item.description}</p>
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </div>
    );
  }
}

SubMenu.propTypes = propTypes;
SubMenu.defaultProps = defaultProps;

export default SubMenu;
